import Vue from 'vue';

export const modalBus = new Vue();
